// TODO: dữ liệu thật khi A-14 gộp. Số mẫu theo script board Mint-Mee (việc cần làm, Tạm ứng của tôi).

export interface TodoRow {
  k: string;
  kind: 'sign' | 'edu' | 'cert';
  /** nhãn chip hạn */
  badge: string;
  tone: 'warn' | 'err';
  tip: string;
  /** chỉ hiện cho quản lý (người có quyền ký phụ lục) */
  mgrOnly?: boolean;
}

export const TODO_SAMPLE: TodoRow[] = [
  { k: 'Ký phụ lục PL-2610-007', kind: 'sign', badge: 'Chờ ký', tone: 'warn', tip: 'HR phát hành 20/Oct/2026', mgrOnly: true },
  { k: 'Release B/L theo mức nợ', kind: 'edu', badge: '−1 ngày', tone: 'err', tip: 'Quá hạn 1 ngày · khoá bắt buộc theo ghế · HANA Edu' },
  { k: 'Gửi bill qua hệ thống', kind: 'edu', badge: '2 ngày', tone: 'warn', tip: 'Còn 2 ngày · khoá bắt buộc · hạn 24/Oct/2026' },
  { k: 'Gia hạn chứng chỉ đại lý hải quan', kind: 'cert', badge: '20 ngày', tone: 'warn', tip: 'Còn 20 ngày' },
];

export interface AdvanceKpi {
  k: string;
  v: string;
  tone: 'tx' | 'warn' | 'err';
  tip: string;
}

/** Tiền tạm ứng của chính người xem (board cho phép hiện); đơn vị triệu đồng. */
export const ADVANCE_SAMPLE: { emp: number; kpis: AdvanceKpi[] } = {
  emp: 4,
  kpis: [
    { k: 'Đang giữ', v: '3,0 tr', tone: 'tx', tip: 'Tạm ứng đang giữ' },
    { k: 'Đã chi', v: '2,1 tr', tone: 'tx', tip: 'Phiếu EMP đã duyệt' },
    { k: 'Chờ duyệt', v: '1 · 0,5 tr', tone: 'warn', tip: 'Phiếu EMP chờ duyệt' },
    { k: 'Bị từ chối', v: '1 · 0,2 tr', tone: 'err', tip: 'Chưa quyết toán · vẫn tính đang giữ' },
    { k: 'Nộp lại', v: '0,4 tr', tone: 'warn', tip: 'Phần thừa phải nộp lại' },
    { k: 'Hạn', v: '31/Oct', tone: 'tx', tip: 'Hạn quyết toán 31/Oct' },
  ],
};
